import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import axios from 'axios';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

// FIX: set withCredentials globally so ALL axios calls send the session cookie
// Previously only set in ProfilePictureUpload.js — other components were missing it
axios.defaults.withCredentials = true;

// FIX: ResizeObserver issue - Global Error Handler
const RESIZE_OBSERVER_ERROR = 'ResizeObserver loop completed with undelivered notifications';
window.addEventListener('error', (e) => {
  if (e.message === RESIZE_OBSERVER_ERROR || e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
    e.stopPropagation();
  }
});

// FIX: ResizeObserver issue - Patch console.error to filter specific warning
const originalError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes(RESIZE_OBSERVER_ERROR)) {
    return;
  }
  originalError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
